
import { Record } from "../fable_modules/fable-library-js.5.3.0/Types.js";
import { ClientTypes_Route, ClientTypes_Msg, ClientTypes_Msg_$reflection, ClientTypes_Model_$reflection } from "./ClientTypes.js";
import { record_type, class_type, lambda_type, unit_type } from "../fable_modules/fable-library-js.5.3.0/Reflection.js";
import { centeredSpinner, PageErrorKind, pageErrorContent } from "./Layout/Interactions.js";
import { printf, toText } from "../fable_modules/fable-library-js.5.3.0/String.js";
import { HtmlHelper_createElement } from "../fable_modules/Feliz.3.3.3/Html.fs.js";
import { fontSize_textSm, display_inlineFlex, margin_mxAuto, border_border2, animation_animateSpin, margin_mb4, fontWeight_fontBold, fontSize_text2Xl, textAlign_center, width_wAuto, width_wFull, gap_gap$002D3, flexDirection_flexRow, fontSize_textLg, height_h12, width_w12, gap_gap$002D4, flexDirection_flexCol, padding_px4, backgroundColor_bgNeutral50, minHeight_minHScreen, justifyContent_justifyCenter, gap_gap$002D2, alignItems_itemsCenter, display_flex, tw } from "../fable_modules/Feliz.Tailwind.4.0.2/Strings.fs.js";
import { TailwindHelpers_linkSecondary, LayoutType, baseLayout, TailwindHelpers_buttonSecondary, TailwindHelpers_buttonPrimary } from "./Layout/Layout.js";
import { empty, singleton, ofArray } from "../fable_modules/fable-library-js.5.3.0/List.js";
import { createElement } from "react";
import { IconWeight, IconSize, IconName, icon } from "./Icons.js";
import { borderColor_borderSecondary600, borderRadius_roundedFull, sm, textColor_textNeutral700, padding_py16 } from "./TailwindExtensions.js";
import { singleton as singleton_1, empty as empty_1, append, delay, toList } from "../fable_modules/fable-library-js.5.3.0/Seq.js";
import { LandingPage_view, Dashboard_dashboardView, navigationHeader } from "./View.js";
import { view as view_1 } from "./Challenge/ChallengesView.js";
import { curry2 } from "../fable_modules/fable-library-js.5.3.0/Util.js";
import { map } from "../fable_modules/fable-library-js.5.3.0/Option.js";
import { PromotionModule_tryFindCharityBySlug } from "./Promotion.js";
import { view as view_2 } from "./User/ProfileView.js";
import { view as view_3 } from "./User/ProfileCompletion.js";
import { view as view_4 } from "./User/RegistrationView.js";
import { view as view_5 } from "./User/VerificationView.js";
import { publicDailyLogHistoryView } from "./Challenge/DailyLogTimeline.js";
import { view as view_6 } from "./PrivacyNotice.js";
import { view as view_7 } from "./TermsOfService.js";
import { view as view_8 } from "./RefundPolicy.js";
import { view as view_9 } from "./FloodReliefPage.js";
import { Clock_system } from "./Clock.js";
import { view as view_10 } from "./Challenge/ChallengePledgeListView.js";
import { view as view_11 } from "./Challenge/DailyLogInterceptionView.js";

/**
 * Pre-bound view renderers for views whose signatures differ between Fable and .NET.
 * Each caller constructs this record with platform-appropriate bindings.
 */
export class ViewDeps extends Record {
    constructor(ManageChallengeView, CreateChallengeView, ChallengeDetailContent, PublicDetailView, PledgeDetailView) {
        super();
        this.ManageChallengeView = ManageChallengeView;
        this.CreateChallengeView = CreateChallengeView;
        this.ChallengeDetailContent = ChallengeDetailContent;
        this.PublicDetailView = PublicDetailView;
        this.PledgeDetailView = PledgeDetailView;
    }
}

export function ViewDeps_$reflection() {
    return record_type("Shared.RouteDispatch.ViewDeps", [], ViewDeps, () => [["ManageChallengeView", lambda_type(ClientTypes_Model_$reflection(), lambda_type(lambda_type(ClientTypes_Msg_$reflection(), unit_type), class_type("Fable.React.ReactElement", undefined)))], ["CreateChallengeView", lambda_type(ClientTypes_Model_$reflection(), lambda_type(lambda_type(ClientTypes_Msg_$reflection(), unit_type), class_type("Fable.React.ReactElement", undefined)))], ["ChallengeDetailContent", lambda_type(ClientTypes_Model_$reflection(), lambda_type(lambda_type(ClientTypes_Msg_$reflection(), unit_type), class_type("Fable.React.ReactElement", undefined)))], ["PublicDetailView", lambda_type(ClientTypes_Model_$reflection(), lambda_type(lambda_type(ClientTypes_Msg_$reflection(), unit_type), class_type("Fable.React.ReactElement", undefined)))], ["PledgeDetailView", lambda_type(ClientTypes_Model_$reflection(), lambda_type(lambda_type(ClientTypes_Msg_$reflection(), unit_type), class_type("Fable.React.ReactElement", undefined)))]]);
}

function accountSetupFailedContent(reason, dispatch) {
    return pageErrorContent(new PageErrorKind(2, [toText(printf("%s\n\nYou can sign out and try again with a different account. If this keeps happening, contact support."))(reason)]), singleton(HtmlHelper_createElement("button", ofArray([["type", "button"], ["className", tw(ofArray([TailwindHelpers_buttonPrimary, display_flex, alignItems_itemsCenter, gap_gap$002D2]))], ["onClick", (_arg) => {
        dispatch(new ClientTypes_Msg(8, []));
    }], ["children", [createElement(icon, {
        name: new IconName(28, []),
        size: new IconSize(1, []),
        weight: new IconWeight(0, []),
    }), HtmlHelper_createElement("span", singleton(["children", singleton("Sign Out")]))]]]))), new IconName(34, []), "We couldn\'t finish setting up your account", undefined);
}

function fullPageBlocking(content) {
    return HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, alignItems_itemsCenter, justifyContent_justifyCenter, minHeight_minHScreen, backgroundColor_bgNeutral50, padding_px4]))], ["children", [content]]]));
}

function accountSetupFailedPage(reason, dispatch) {
    return fullPageBlocking(accountSetupFailedContent(reason, dispatch));
}

const maintenanceContent = pageErrorContent(new PageErrorKind(2, ["We are making some improvements. Please try again in a few minutes."]), empty(), new IconName(41, []), "You-Thon is down for maintenance", undefined);

const maintenancePage = fullPageBlocking(maintenanceContent);

function authGuardView(signInMsg, signUpReturnRoute, backLink, dispatch, auth) {
    switch (auth.tag) {
        case 2:
            return centeredSpinner;
        case 3:
            return accountSetupFailedContent(auth.fields[0], dispatch);
        case 4:
            return maintenanceContent;
        case 1:
            return undefined;
        default:
            return HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, flexDirection_flexCol, alignItems_itemsCenter, justifyContent_justifyCenter, padding_py16, gap_gap$002D4]))], ["children", toList(delay(() => {
                let matchValue;
                return append((matchValue = backLink, (matchValue == null) ? (empty_1()) : singleton_1(matchValue)), delay(() => append((signUpReturnRoute != null) ? singleton_1(HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, alignItems_itemsCenter, justifyContent_justifyCenter, width_w12, height_h12, "text-neutral-300"]))], ["children", [createElement(icon, {
                    name: new IconName(25, []),
                    size: new IconSize(2, []),
                    weight: new IconWeight(0, []),
                })]]]))) : empty_1(), delay(() => append(singleton_1(HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textLg, textColor_textNeutral700]))], ["children", singleton(signInMsg)]]))), delay(() => singleton_1(HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, flexDirection_flexCol, sm(flexDirection_flexRow), alignItems_itemsCenter, gap_gap$002D3, width_wFull, sm(width_wAuto)]))], ["children", toList(delay(() => {
                    let matchValue_1, returnRoute;
                    return append((matchValue_1 = signUpReturnRoute, (matchValue_1 == null) ? (empty_1()) : ((returnRoute = matchValue_1, singleton_1(HtmlHelper_createElement("button", ofArray([["className", tw(ofArray([TailwindHelpers_buttonPrimary, display_flex, alignItems_itemsCenter, justifyContent_justifyCenter, gap_gap$002D2, width_wFull, sm(width_wAuto)]))], ["onClick", (_arg) => {
                        dispatch(new ClientTypes_Msg(3, [returnRoute]));
                    }], ["children", [createElement(icon, {
                        name: new IconName(25, []),
                        size: new IconSize(1, []),
                        weight: new IconWeight(0, []),
                    }), HtmlHelper_createElement("span", singleton(["children", singleton("Create account")]))]]])))))), delay(() => singleton_1(HtmlHelper_createElement("button", ofArray([["className", tw(ofArray([TailwindHelpers_buttonSecondary, display_flex, alignItems_itemsCenter, justifyContent_justifyCenter, gap_gap$002D2, width_wFull, sm(width_wAuto)]))], ["onClick", (_arg_1) => {
                        dispatch(new ClientTypes_Msg(1, []));
                    }], ["children", [createElement(icon, {
                        name: new IconName(24, []),
                        size: new IconSize(1, []),
                        weight: new IconWeight(0, []),
                    }), HtmlHelper_createElement("span", singleton(["children", singleton("Sign In")]))]]])))));
                }))]])))))))));
            }))]]));
    }
}

function fullPageSpinner(title) {
    return HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, alignItems_itemsCenter, justifyContent_justifyCenter, minHeight_minHScreen, backgroundColor_bgNeutral50]))], ["children", [HtmlHelper_createElement("div", ofArray([["className", textAlign_center], ["children", [HtmlHelper_createElement("h2", ofArray([["className", tw(ofArray([fontSize_text2Xl, fontWeight_fontBold, margin_mb4]))], ["children", singleton(title)]])), HtmlHelper_createElement("div", singleton(["className", tw(ofArray([animation_animateSpin, borderRadius_roundedFull, height_h12, width_w12, border_border2, borderColor_borderSecondary600, margin_mxAuto]))]))]]]))]]]));
}

/**
 * Decides whether the Challenge route renders the public detail view (true)
 * or the owner manage view (false). Extracted so it can be unit-tested directly.
 */
export function showPublicChallengeView(auth, challenge, currentUserId) {
    let matchResult, ch, uid;
    switch (auth.tag) {
        case 0: {
            matchResult = 0;
            break;
        }
        case 1: {
            if (challenge != null) {
                if (currentUserId == null) {
                    matchResult = 2;
                }
                else {
                    matchResult = 1;
                    ch = challenge;
                    uid = currentUserId;
                }
            }
            else {
                matchResult = 3;
            }
            break;
        }
        default:
            matchResult = 3;
    }
    switch (matchResult) {
        case 0:
            return true;
        case 1:
            return uid !== ch.UserId;
        case 2:
            return true;
        default:
            return false;
    }
}

/**
 * Decides whether the authenticated Home route renders the daily-log interception flow (true)
 * or proceeds to the dashboard (false). Extracted so it can be unit-tested directly.
 */
export function showsDailyLogInterception(interception) {
    switch (interception.tag) {
        case 0:
            return false;
        default:
            return true;
    }
}

function usableAccountRouteContent(deps, model, dispatch) {
    let charity;
    const withLayout = (layoutType, content) => baseLayout(navigationHeader(model, dispatch), layoutType, content);
    const matchValue = model.CurrentRoute;
    switch (matchValue.tag) {
        case 1:
            return withLayout(new LayoutType(2, []), view_1(model, dispatch));
        case 2:
            return withLayout(new LayoutType(1, []), (showPublicChallengeView(model.Auth, model.CurrentChallenge, model.CurrentUserId) ? curry2(deps.PublicDetailView) : curry2(deps.ManageChallengeView))(model)(dispatch));
        case 3:
        case 4: {
            let promotedCharity;
            const matchValue_2 = model.CurrentRoute;
            promotedCharity = ((matchValue_2.tag === 4) ? map((tuple) => tuple[1], PromotionModule_tryFindCharityBySlug(matchValue_2.fields[0])) : undefined);
            const matchValue_3 = authGuardView((promotedCharity == null) ? "You must be signed in to create a challenge." : ((charity = promotedCharity, toText(printf("Sign in or create an account to start a challenge benefiting %s."))(charity.CharityName))), model.CurrentRoute, map((_arg) => HtmlHelper_createElement("a", ofArray([["className", tw(ofArray([TailwindHelpers_linkSecondary, display_inlineFlex, alignItems_itemsCenter, gap_gap$002D2, fontSize_textSm, "self-start"]))], ["href", "/flood-relief"], ["onClick", (e) => {
                e.preventDefault();
                dispatch(new ClientTypes_Msg(18, [new ClientTypes_Route(16, [])]));
            }], ["children", [createElement(icon, {
                name: new IconName(37, []),
                size: new IconSize(0, []),
                weight: new IconWeight(0, []),
            }), HtmlHelper_createElement("span", singleton(["children", singleton("Back to flood relief")]))]]])), promotedCharity), dispatch, model.Auth);
            if (matchValue_3 == null) {
                return withLayout(new LayoutType(1, []), deps.CreateChallengeView(model, dispatch));
            }
            else {
                return withLayout(new LayoutType(1, []), matchValue_3);
            }
        }
        case 5: {
            const matchValue_4 = authGuardView("You must be signed in to view your profile.", undefined, undefined, dispatch, model.Auth);
            if (matchValue_4 == null) {
                return withLayout(new LayoutType(1, []), view_2(model, dispatch));
            }
            else {
                return withLayout(new LayoutType(1, []), matchValue_4);
            }
        }
        case 6:
            return withLayout(new LayoutType(1, []), view_3(model, dispatch));
        case 7:
            return fullPageSpinner("Processing login...");
        case 8:
            return withLayout(new LayoutType(1, []), createElement(view_4, {
                model: model,
                dispatch: dispatch,
            }));
        case 9:
            return withLayout(new LayoutType(1, []), view_5(model, dispatch, matchValue.fields[0]));
        case 10:
            return withLayout(new LayoutType(1, []), deps.PledgeDetailView(model, dispatch));
        case 12:
            return withLayout(new LayoutType(1, []), createElement(publicDailyLogHistoryView, {
                model: model,
                dispatch: dispatch,
            }));
        case 13:
            return withLayout(new LayoutType(1, []), view_6());
        case 14:
            return withLayout(new LayoutType(1, []), view_7());
        case 15:
            return withLayout(new LayoutType(1, []), view_8());
        case 16:
            return withLayout(new LayoutType(0, []), view_9(Clock_system.UtcNow(), dispatch));
        case 11: {
            const matchValue_5 = authGuardView("You must be signed in to view this page.", undefined, undefined, dispatch, model.Auth);
            if (matchValue_5 == null) {
                return withLayout(new LayoutType(1, []), view_10(model, dispatch));
            }
            else {
                return withLayout(new LayoutType(1, []), matchValue_5);
            }
        }
        default: {
            const matchValue_1 = model.Auth;
            switch (matchValue_1.tag) {
                case 1:
                    if (showsDailyLogInterception(model.DailyLogInterception)) {
                        return withLayout(new LayoutType(1, []), view_11(model, dispatch));
                    }
                    else {
                        return withLayout(new LayoutType(2, []), Dashboard_dashboardView(deps.ChallengeDetailContent, model, dispatch));
                    }
                case 2:
                case 3:
                case 4:
                    return withLayout(new LayoutType(0, []), centeredSpinner);
                default:
                    return withLayout(new LayoutType(0, []), LandingPage_view(model, dispatch));
            }
        }
    }
}

/**
 * Unified route dispatch. Returns the view content for the given route,
 * wrapped in the appropriate layout (FullWidth, Dashboard, or Centered).
 */
export function routeContent(deps, model, dispatch) {
    const matchValue = model.Auth;
    switch (matchValue.tag) {
        case 4:
            return maintenancePage;
        case 0:
        case 2:
        case 1:
            return usableAccountRouteContent(deps, model, dispatch);
        default:
            return accountSetupFailedPage(matchValue.fields[0], dispatch);
    }
}

//# sourceMappingURL=RouteDispatch.js.map
